import { render } from "./EcommercePage.vue?vue&type=template&id=6228c2de&scoped=true&ts=true"
import script from "./EcommercePage.vue?vue&type=script&lang=ts"
export * from "./EcommercePage.vue?vue&type=script&lang=ts"

import "./EcommercePage.vue?vue&type=style&index=0&id=6228c2de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6228c2de"]])

export default __exports__